import { useMemo } from "react";
import { useLocation } from "@remix-run/react";

import { useStateManager } from "~/modules/StateManager.hooks";

export function useActiveStep() {
  const pathname = useLocation().pathname;
  const { steps } = useStateManager();

  return useMemo(() => {
    const activeStep = steps.find((step) => pathname.endsWith(step.pathname));

    const visibleNonLockedSteps = steps.filter((step) => !step.locked && step.visible);
    const prevIdx = activeStep
      ? visibleNonLockedSteps.findIndex(({ id }) => id === activeStep.id) - 1
      : -1;

    const prevStep = prevIdx !== -1 ? visibleNonLockedSteps[prevIdx] : undefined;

    return { activeStep, prevStep };
  }, [pathname, steps]);
}
